<template lang="pug">
div(v-if="cadastroFormulario")
  el-alert.margin-bottom(
      v-if="inputsExtraCadastro.georreferencia.texto"
      title="Atenção",
      type="info")
      span O Georreferenciamento deve ser da área atual
  div
    div(v-if="showGeorreferenciamentoOption")
      validation-provider(rules="required", v-slot="{ errors }", name="Georreferenciamento/Possui Georreferenciamento'")
        app-label(label="Possui o georreferenciamento do imóvel de acordo com as normas técnicas em vigência?")
        el-radio(v-model="cadastroFormulario.georreferenciamento.possuiGeorreferenciamento" :disabled="isDesable()" label="POSSUI") Sim
        el-radio(v-model="cadastroFormulario.georreferenciamento.possuiGeorreferenciamento" :disabled="isDesable()" label="NAO_POSSUI") Não
        span.help.erro {{ errors[0] }}

    div.mapa(v-if="cadastroFormulario.georreferenciamento.possuiGeorreferenciamento === 'NAO_POSSUI'")
      validation-provider(rules="required", v-slot="{ errors }", name="Georreferenciamento/Geometria")
        mapa-retificacao(
          v-model="localizacoes",
          :localizacoes="localizacoes"
          name="Geometria",
          idMapa="mapaCadastroGeo"
          :errors="errors"
          :addPonto="true"
        )
        span.help.erro {{ errors[0] }}

    div(v-if="cadastroFormulario.georreferenciamento.possuiGeorreferenciamento === 'POSSUI'")
      div.texto-informativo
        el-alert(
          :title="''"
          :closable="false"
        )
          p(v-html="textGeorreferenciamento")
      app-dados-responsavel(
        :responsavel="cadastroFormulario.georreferenciamento.responsavel"
        nomeAba="Georreferenciamento"
      )

      app-documentos-retificacao(
        @mudaTipo="mudaTipo"
        :maxSize='25000',
        :valid-extensions="extensoes",
        :documentos="documentosGeorreferenciamento"
        :tiposDocumentos="tiposDocumentos"
        :tiposDocumentosObrigatorios="tiposDocumentos"
        :observer="observer",
        :pecasTecnicas="true"
        @setDadosPlanilha="setDadosPlanilha"
        @addedDoc="handleDocs",
        @removedDoc="removerDocs"
        aba="Georreferenciamento"
      )

</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import FileSaver from 'file-saver'
import axios from '@/utils/api'
import { validate } from 'vee-validate'
import MapaRetificacao from '@/screens/central/components/MapaRetificacao'
import AppDadosResponsavel from '@/components/AppDadosResponsavel'
import AppDocumentosRetificacao from '@/screens/central/components/cadastro/AppDocumentosRetificacao'
import AppLabel from '@/components/AppLabel'
const {inputsExtraCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default
const tipoDocumentos = require('@/utils/tipoDocumentos').default

export default {

  components: {
    MapaRetificacao,
    AppDadosResponsavel,
    AppDocumentosRetificacao,
    AppLabel
  },

  props: ['cadastro', 'observer', 'idProcesso'],

  data () {
    return {
      documentos: [],
      inputsExtraCadastro,
      extensoes: ['pdf', 'rar', 'zip', 'ods', 'xls', 'xlsx'],
      possuiGeorreferenciamento: true,
      cadastroFormulario: null,
      showGeorreferenciamentoOption: true,
      tiposDocumentos: [],
      textGeorreferenciamento: 'O georreferenciamento deverá estar de acordo com as normas técnicas para georreferenciamento de imóveis rurais em vigência, editadas pelo INCRA e normas do ITERPA.',
      documentosGeorreferenciamento: [],
      listDocs: null,
      listDocsRemovidos: [],
      denominacao: null,
      tipoPlanilha: null,
      jsonPlanilha: null,
      tipoDoCadastro: null
    }
  },

  async created () {
    const jsonCadastro = await this.findByIdCadastro(this.idProcesso)
    this.CADASTRO_INICIAL(JSON.parse(jsonCadastro.json))
    this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    this.documentos = await this.findDocumentos('geo')
    this.tiposDocumentos = this.findTipoDocumentos().sort((a, b) => a.descricao.localeCompare(b.descricao))
    this.documentosGeorreferenciamento = this.cadastroFormulario?.georreferenciamento.documentos
    this.tipoCadastro = this.tipo.replace(/['"]/g, '')
  },

  computed: {
    localizacoes () {
      return this.cadastroFormulario?.georreferenciamento?.localizacoes ? this.cadastroFormulario?.georreferenciamento?.localizacoes.map(l => l.geometry) : []
    },
    ...mapGetters({
      cadastroJson: 'retificacao/cadastro',
      versao: 'retificacao/versao',
      tipo: 'retificacao/tipo'
    })
  },

  methods: {
    ...mapActions({
      findByIdCadastro: 'cadastro/findCadastroById',
      findTiposDocumentosObrigatorios: 'documentos/findTiposDocumentosObrigatoriosGeo',
      findDocumentos: 'tipoDocumento/findTiposDocumento',
      baixarDocumento: 'cadastro/downloadDocumentoCentral',
      salvarCadastroRetificacao: 'cadastroRetificacao/salvarCadastroByIdProcesso',
      deleteDocumentoById: 'documentos/deleteDocumentoById',
      saveRelDocumentoProcessoRetificacao: 'relDocumentoProcessoRetificacao/saveRelDocumentoProcessoRetificacao'
    }),
    ...mapActions('retificacao', ['update']),
    ...mapMutations(
      'retificacao', [
        'CADASTRO_INICIAL', 'UPDATE_GEORREFERENCIAMENTO'
      ]
    ),

    isDesable () {
      return this.tipoCadastro === 'ONEROSO'
    },

    setDadosPlanilha (valor) {
      const planilhaJson = JSON.parse(valor.jsonPlanilha)
      this.denominacao = planilhaJson.identificacaoPlanilha.denominacao
      this.jsonPlanilha = valor.jsonPlanilha
      this.tipoPlanilha = valor.tipoPlanilha
    },
    mudaTipo (opcao) {
      switch (opcao.tipo) {
        case 'RELATORIO_TECNICO_DE_EXECUCAO_DO_GEOPROCESSAMENTO':
        case 'ART_TRT':
          this.extensoes = ['pdf']
          break
        case 'RELATORIO_DE_PROCESSAMENTO':
        case 'ARQUIVOS_GNSS':
          this.extensoes = ['zip']
          break
        case 'TABELA_DADOS_CARTOGRAFICOS':
          this.extensoes = ['ods', 'xlsx']
          break
      }
    },
    findTipoDocumentos () {
      return tipoDocumentos.filter(item => item.cadastroOnerosoAndNaoOneroso)
    },
    async handleDocs (dados) {
      const doc = {
        id: null,
        _id: dados.id,
        key: dados.fileKey,
        hash: null,
        nome: dados.fileName,
        tipo: dados.tipoDocumento,
        base64: null,
        caminho: null
      }
      const newDoc = await this.createDocByKey(doc)
      this.documentosGeorreferenciamento.push(newDoc)
      this.documentosGeorreferenciamento = this.documentosGeorreferenciamento.filter(item => item.caminho)
      this.listDocs = [...this.documentosGeorreferenciamento]
      const payload = {
        idDocumento: newDoc.id,
        idProcesso: this.idProcesso
      }
      await this.saveRelDocumentoProcessoRetificacao(payload)
    },

    async removerDocs (doc) {
      const listaDocumentos = this.cadastroFormulario?.georreferenciamento?.documentosRemovidos
        ? this.cadastroFormulario.georreferenciamento.documentosRemovidos
        : []
      this.listDocsRemovidos = [...listaDocumentos, doc]
      this.listDocs = [...this.documentosGeorreferenciamento.filter(documento => doc.id !== documento.id)]
      if (doc?.id) {
        await this.deleteDocumentoById(doc.id)
      }
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.fileName)
    },
    async createDocByKey (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/createByKey`,
        data: documento
      })
      return file
    },

    downloadArquivo (arquivo) {
      this.getDownload(arquivo)
    },

    montarJson () {
      const jsonCadastro = {
        tipo: this.tipo,
        versao: this.versao,
        dados: {
          cadastro: this.cadastroFormulario
        }
      }
      return JSON.stringify(jsonCadastro)
    }

  },

  watch: {
    async localizacoes (val) {
      await validate('required', {
        skipIfEmpty: false
      })
    },
    'cadastroFormulario.georreferenciamento.possuiGeorreferenciamento' (val) {
      this.UPDATE_GEORREFERENCIAMENTO(val)
      this.update({ field: 'georreferenciamento.possuiGeorreferenciamento', value: val })
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    },
    'cadastroFormulario.georreferenciamento.responsavel.nome' (val) {
      this.update({ field: 'georreferenciamento.responsavel.nome', value: val })
    },
    'cadastroFormulario.georreferenciamento.responsavel.formacao' (val) {
      this.update({ field: 'georreferenciamento.responsavel.formacao', value: val })
    },
    'cadastroFormulario.georreferenciamento.responsavel.creaRnp' (val) {
      this.update({ field: 'georreferenciamento.responsavel.creaRnp', value: val })
    },
    'cadastroFormulario.georreferenciamento.responsavel.codigoIncra' (val) {
      this.update({ field: 'georreferenciamento.responsavel.codigoIncra', value: val })
    },
    listDocs (val) {
      this.update({ field: 'georreferenciamento.documentos', value: val })
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      const payload = {
        idProcesso: this.idProcesso,
        cadastro: this.montarJson()
      }
      this.salvarCadastroRetificacao(payload)
    },
    'denominacao' (val) {
      this.update({ field: 'georreferenciamento.denominacao', value: val })
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    },
    'jsonPlanilha' (val) {
      this.update({ field: 'georreferenciamento.jsonPlanilha', value: val })
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    },
    'tipoPlanilha' (val) {
      this.update({ field: 'georreferenciamento.tipoPlanilha', value: val })
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    },
    listDocsRemovidos (val) {
      this.update({ field: 'georreferenciamento.documentosRemovidos', value: val })
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    }
  }

}
</script>

<style lang="scss" scoped>
  .mapa {
    height: 100%;
    margin: 10px 0 20px 0px;
  }

  .margin-bottom {
    margin-bottom: 20px;
  }
  .texto-informativo {
    margin: 20px;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/GeorreferenciamentoRetificacao.vue